import { toBig } from '@src/utils/number';
import { type ConfirmParam, ConfirmTypeEnum } from '../../types/Confirm';
import { HStack } from '../Core/HStack';
import { Stack } from '../Core/Stack';
import { InlineFormattedNumber } from '../FormattedNumber/InlineFormattedNumber';
import type { InlineFormattedNumberFormattedProps } from '../FormattedNumber/types';
import { Text } from '../Text';
import { Tooltip } from '../Tooltip';

export function ConfirmPrice({
  confirm,
  ...ifnProps
}: { confirm: ConfirmParam } & Omit<InlineFormattedNumberFormattedProps, 'number' | 'currency'>) {
  if (confirm.ConfirmType === ConfirmTypeEnum.RepoConfirm) {
    return (
      <Tooltip tooltip={<ConfirmPriceTooltipContent confirm={confirm} />} showUnderline>
        <InlineFormattedNumber
          number={toBig(confirm.Confirm.Rate)?.times(100)}
          currency="%"
          {...ifnProps}
          increment="0.01"
        />
      </Tooltip>
    );
  }

  return null; // unknown / unsupported, don't try to be clever
}

function ConfirmPriceTooltipContent({ confirm }: { confirm: ConfirmParam }) {
  if (confirm.ConfirmType === ConfirmTypeEnum.RepoConfirm) {
    return (
      <Stack data-testid="confirm-tooltip-content" gap="spacing4" color="colorTextImportant" minWidth="140px">
        <Text fontWeight={500} color="colorTextDefault">
          Confirm Details
        </Text>

        <HStack data-testid="confirm-tooltip-row" justifyContent="space-between" gap="spacing8">
          <Text color="colorTextDefault">Rate</Text>
          <InlineFormattedNumber
            number={toBig(confirm.Confirm.Rate)?.times(100)}
            currency="%"
            increment="0.01"
            align="right"
          />
        </HStack>

        <HStack data-testid="confirm-tooltip-row" justifyContent="space-between" gap="spacing8">
          <Text color="colorTextDefault">Haircut</Text>
          <InlineFormattedNumber
            number={toBig(confirm.Confirm?.HaircutRatio)?.times(100)}
            currency="%"
            increment="0.01"
            align="right"
          />
        </HStack>
      </Stack>
    );
  }

  return null; // unknown, don't be clever
}
